import { render, staticRenderFns } from "./ShopLMSCatalog.vue?vue&type=template&id=cb6b103a&scoped=true&"
import script from "./ShopLMSCatalog.vue?vue&type=script&lang=js&"
export * from "./ShopLMSCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ShopLMSCatalog.vue?vue&type=style&index=0&id=cb6b103a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b103a",
  null
  
)

export default component.exports